import axios from "axios";
import { serverConfig } from "./serverConfig";

// Create a corridor
export const createCorridor = async (requestData) => {
  const token = localStorage.getItem("jwtToken");

  const options = {
    method: "POST",
    url: `${serverConfig.serverAddress}/corridor/create`,
    data: requestData,
    headers: {
      "Content-Type": "application/json",
      "api-key": serverConfig.apiKey,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(options);
    return {
      status: response.status,
      message: response.data.message || response.statusText,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || error.response?.statusText || "Failed to create corridor",
    };
  }
};

// Edit a corridor
export const editCorridor = async (corridorId, requestData) => {
  const token = localStorage.getItem("jwtToken");

  const options = {
    method: "PUT",
    url: `${serverConfig.serverAddress}/corridor/${corridorId}/edit`,
    data: requestData,
    headers: {
      "Content-Type": "application/json",
      "api-key": serverConfig.apiKey,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(options);
    return {
      status: response.status,
      message: response.data.message || response.statusText,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || error.response?.statusText || "Failed to edit corridor",
    };
  }
};

// Delete a corridor
export const deleteCorridor = async (corridorId) => {
  const token = localStorage.getItem("jwtToken");

  const options = {
    method: "DELETE",
    url: `${serverConfig.serverAddress}/corridor/${corridorId}/delete`,
    headers: {
      "api-key": serverConfig.apiKey,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(options);
    return {
      status: response.status,
      message: response.data.message || response.statusText,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || error.response?.statusText || "Failed to delete corridor",
    };
  }
};

// Get all corridors
export const getAllCorridors = async () => {
  const token = localStorage.getItem("jwtToken");

  const options = {
    method: "GET",
    url: `${serverConfig.serverAddress}/corridor/get`,
    headers: {
      "api-key": serverConfig.apiKey,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios(options);
    return {
      status: response.status,
      message: response.data.message || response.statusText,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || error.response?.statusText || "Failed to fetch corridors",
    };
  }
};
